import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	placeholderDate: {
		id: 'common-date.utils.date-messages.placeholder-date',
		defaultMessage: 'e.g. 2018/12/31',
		description: '',
	},
});
